module.exports = __webpack_public_path__ + "static/img/card-themes_on.43873f6a.png";